export const WABA_CALLING_EVENTS = {
  INCOMING: 'astrachat_whatsapp_calling.incoming',
  UPDATED: 'astrachat_whatsapp_calling.updated',
  CLAIMED: 'astrachat_whatsapp_calling.claimed',
  ENDED: 'astrachat_whatsapp_calling.ended',
};

export const WABA_CALLING_BUS_EVENT = 'astrachat:whatsapp-waba-calling';
